import { useQuery } from '@tanstack/react-query'
import {
  listOepDocuments,
  type OepDocumentListItemDto,
} from 'modules/annual-benefit-planning/modules/approval/infra/api/config.api'
import { APPROVAL_QUERY_KEYS } from 'modules/annual-benefit-planning/modules/approval/infra/react-query/approval.query-keys'

interface Options {
  readonly clientId: string
  readonly oepId: string | null
}

/**
 * Backs the Analysis Files table (EMS-10154 FR-013): every non-deleted
 * document for one OEP, newest first. `oepId` comes from the policy
 * endpoint's current OEP (EMS-10573); `null` (policy still loading, or the
 * client has no OEP) holds the query. Refetches whenever
 * `useOepDocumentUpload`, `useOepDocumentRowActions` or a status poll
 * invalidate the per-client `APPROVAL_QUERY_KEYS.oepDocumentList` prefix.
 */
export function useOepDocumentList({ clientId, oepId }: Options) {
  return useQuery<OepDocumentListItemDto[]>({
    queryKey: APPROVAL_QUERY_KEYS.oepDocumentList(clientId, oepId ?? undefined),
    queryFn: () => listOepDocuments(clientId, oepId ?? undefined),
    enabled: clientId !== '' && oepId !== null,
  })
}
